export const SEARCH_FIELD = [
    { label: '订单编号', value: 'sn' },
    { label: '用户昵称', value: 'nickname' },
    { label: '手机号码', value: 'phoneNumber' },
    { label: '礼品编码', value: 'giftCode' },
    { label: '礼品名称', value: 'giftTitle' },
]

export const ORDER_STATUS = Object.freeze({
    /**
     * 待支付
     */
    unpaid: 'unpaid',
    /**
     * 待发货
     */
    unshipped: 'unshipped',
    /**
     * 待收货
     */
    shipped: 'shipped',
    /**
     * 已完成
     */
    completed: 'completed',
    /**
     * 已取消
     */
    cancelled: 'cancelled',

    options() {
        return [
            // { label: '待支付', value: this.unpaid, color: '#F5222D' },
            { label: '待发货', value: this.unshipped, color: '#1890FF' },
            { label: '待收货', value: this.shipped, color: '#FA8C16' },
            { label: '已完成', value: this.completed, color: '#52C41A' },
            { label: '已取消', value: this.cancelled, color: '#d9d9d9' }
        ]
    },
    filterValue(value) {
        return this.options().find(op => op.value === value)?.label
    },
    giftOptions() {
        return [
            { label: '待发货', value: this.unshipped, color: '#1890FF', type: 'primary' },
            { label: '待收货', value: this.shipped, color: '#FA8C16', type: 'success' },
            { label: '已完成', value: this.completed, color: '#52C41A', type: 'info' }
        ]
    },
    giftFilterValue(value) {
        return this.giftOptions().find(op => op.value === value)?.label
    },
    giftBadge(value) {
        return this.giftOptions().find(op => op.value === value)?.type
    },
    shopOptions() {
        return [
            { label: '待支付', value: this.unpaid, color: '#F5222D' },
            { label: '待发货', value: this.unshipped, color: '#1890FF' },
            { label: '待收货', value: this.shipped, color: '#FA8C16' },
            { label: '已完成', value: this.completed, color: '#52C41A' },
            { label: '已取消', value: this.cancelled, color: '#d9d9d9' }
        ]
    },
    shopFilterValue(value) {
        return this.shopOptions().find(op => op.value === value)?.la
    }
})

/* 订单来源 */
export const ORDER_SOURCE = Object.freeze({
    /**
     * 积分商城
     */
    credit: 'credit_good',
    /**
     * 试用活动
     */
    trail: 'trail',
    /**
     * 抽奖活动
     */
    draw: 'draw_activity',
    /**
     * 签到活动
     */
    sign: 'sign_activity',
    /**
     * 邀请活动
     */
    invite: 'invite_activity',
    /**
     * 注册活动
     */
    register: 'register_activity',
    /**
     * 有奖调查活动
     */
    questionnaire:  'questionnaire_activity',

    options() {
        return [
            { label: '积分商城', value: this.credit },
            { label: '抽奖活动', value: this.draw },
            { label: '签到活动', value: this.sign },
            { label: '邀请活动', value: this.invite },
            { label: '注册活动', value: this.register },
            { label: '有奖调查活动', value: this.questionnaire}
        ]
    },
    filterValue(value) {
        return this.options().find(op => op.value === value)?.label
    }
})

export const ORDER_TYPE = Object.freeze({
    entity: 'entity',
    invented: 'invented',
})

export const GIFT_ORDER_STATUS = Object.freeze({
    getStatus(row) {
        if (row.status == 'completed') {
            return 'completed'
        } else if (row.status == 'normal' && row.shippingStatus == 'shipped') {
            return 'shipped'
        } else if (row.status == 'normal' && row.shippingStatus == 'unshipped') {
            return 'unshipped'
        } else if (row.status == 'cancelled') {
            return 'cancelled'
        }
    }
})
